"use client";
import { useState } from "react";
import { useRouter } from "next/navigation"; // Plus propre que window.location

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [resetToken, setResetToken] = useState(""); // Stocké séparément
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/forgot-password/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // Envoi explicite d'un objet simple
        body: JSON.stringify({ workEmail: email, phoneNumber: phone }),
      });
      
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Erreur de vérification");
      
      setResetToken(data.resetToken);
      setStep(2);
      setError("");
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ resetToken, newPassword: password }),
      });
      
      if (!res.ok) throw new Error("Erreur lors de la mise à jour");
      router.push("/signin"); // Redirection propre
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <form 
        className="max-w-[400px] w-full p-6 shadow-lg rounded-lg bg-white" 
        onSubmit={step === 1 ? handleVerify : handleReset}
      >
        <h1 className="text-2xl font-semibold mb-6 text-blue-900">
          {step === 1 ? "Récupérer votre compte" : "Nouveau mot de passe"}
        </h1>
        
        {step === 1 ? (
          <>
            <input type="email" placeholder="Email" className="form-input w-full mb-4 border p-2" onChange={(e) => setEmail(e.target.value)} required />
            <input type="text" placeholder="Numéro de téléphone" className="form-input w-full mb-4 border p-2" onChange={(e) => setPhone(e.target.value)} required />
          </>
        ) : (
          <input type="password" placeholder="Nouveau mot de passe" className="form-input w-full mb-4 border p-2" onChange={(e) => setPassword(e.target.value)} required />
        )}

        <button type="submit" className="w-full btn bg-[rgb(82,146,158)] text-white p-2 rounded" disabled={loading}>
          {loading ? "Chargement..." : (step === 1 ? "Vérifier" : "Réinitialiser")}
        </button>
        {error && <p className="text-red-500 text-sm mt-4 text-center">{error}</p>}
      </form>
    </div>
  );
}